import { render, staticRenderFns } from "./PixelConfig.vue?vue&type=template&id=3061a980&scoped=true&"
import script from "./PixelConfig.vue?vue&type=script&lang=js&"
export * from "./PixelConfig.vue?vue&type=script&lang=js&"
import style0 from "./PixelConfig.vue?vue&type=style&index=0&id=3061a980&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3061a980",
  null
  
)

export default component.exports